// Module
var code = "<react-component name=\"ShowGradingEvent\"></react-component>\n";
// Exports
module.exports = code;